import React, { useState } from 'react'
import {FileText, BookOpen, Shield, Lock, Flag} from 'lucide-react'
import { HowItWorksModal } from './HowItWorksModal'
import { DocsModal } from './DocsModal'
import { TermsModal } from './TermsModal'
import { SecurityAuditModal } from './SecurityAuditModal'
import { ReportModal } from './ReportModal'

export function Footer() {
  const [showHowItWorks, setShowHowItWorks] = useState(false)
  const [showDocs, setShowDocs] = useState(false)
  const [showTerms, setShowTerms] = useState(false)
  const [showAudit, setShowAudit] = useState(false)
  const [showReport, setShowReport] = useState(false)

  return (
    <>
      <footer className="border-t border-deep-purple-900/50 bg-black/80 backdrop-blur-xl mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="flex flex-col md:flex-row justify-between items-center gap-8">
            <div className="flex items-center gap-3">
              <img 
                src="https://static.lumi.new/2d/2db01c8af5f8d23adc3535b856a32a22.webp" 
                alt="XyberMart" 
                className="h-10 object-contain"
              />
            </div>

            <div className="flex flex-wrap justify-center gap-8">
              <button
                onClick={() => setShowHowItWorks(true)}
                className="flex items-center gap-2 text-gray-400 hover:text-electric-purple-500 transition-colors"
              >
                <BookOpen className="w-4 h-4" />
                <span className="font-medium">How it Works</span>
              </button>

              <button
                onClick={() => setShowDocs(true)}
                className="flex items-center gap-2 text-gray-400 hover:text-electric-purple-500 transition-colors"
              >
                <FileText className="w-4 h-4" />
                <span className="font-medium">Docs</span>
              </button>

              <button
                onClick={() => setShowTerms(true)}
                className="flex items-center gap-2 text-gray-400 hover:text-electric-purple-500 transition-colors"
              >
                <Shield className="w-4 h-4" />
                <span className="font-medium">Terms and Conditions</span>
              </button>

              <button
                onClick={() => setShowAudit(true)}
                className="flex items-center gap-2 text-gray-400 hover:text-electric-purple-500 transition-colors"
              >
                <Lock className="w-4 h-4" />
                <span className="font-medium">Security Audit</span>
              </button>

              <button
                onClick={() => setShowReport(true)}
                className="flex items-center gap-2 text-gray-400 hover:text-electric-purple-500 transition-colors"
              >
                <Flag className="w-4 h-4" />
                <span className="font-medium">Report Bug/User</span>
              </button>
            </div>

            <div className="text-gray-500 text-sm">
              © 2026 XyberMart. All rights reserved.
            </div>
          </div>
        </div>
      </footer>

      <HowItWorksModal isOpen={showHowItWorks} onClose={() => setShowHowItWorks(false)} />
      <DocsModal isOpen={showDocs} onClose={() => setShowDocs(false)} />
      <TermsModal isOpen={showTerms} onClose={() => setShowTerms(false)} />
      <SecurityAuditModal isOpen={showAudit} onClose={() => setShowAudit(false)} />
      <ReportModal isOpen={showReport} onClose={() => setShowReport(false)} />
    </>
  )
}
